import { PASSWORD_RESET_CLEAR, PASSWORD_RESET_CREATE, PASSWORD_RESET_UPDATE } from '../constants/passwordResetTypes';

export function passwordResetClear() {
  return { type: PASSWORD_RESET_CLEAR };
}

export function passwordResetCreate(email) {
  return {
    type: PASSWORD_RESET_CREATE,
    payload: { email }
  };
}

export function passwordResetUpdate(token, password, passwordConfirmation) {
  return {
    type: PASSWORD_RESET_UPDATE,
    payload: { token, password, passwordConfirmation }
  };
}



// WEBPACK FOOTER //
// ./app/actions/passwordResetActions.js